module.exports = __webpack_public_path__ + "img/terms_c.f83e1c11.svg";